import { Injectable } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { Observable, of, BehaviorSubject, Subject } from 'rxjs'
import { QUOTEDETAILSRES } from './quote-details/quote-details.model'
import { HttpParams } from '@angular/common/http'
import { share } from 'rxjs/operators'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../shared/services/common.service'
export const headerOptions = { responseType: 'text' as 'json' }

@Injectable({
  providedIn: 'root',
})
export class QuoteTrackingService {
  userType: string
  cartId: string
  cartId$: Observable<string> = this.activeCartService.getActiveCartId()
  activeCart: any
  rfqCartId: any
  public mergeQuoteSource = new BehaviorSubject([])
  getQuotesForMerge = this.mergeQuoteSource.asObservable()

  public mergeQuoteDetailsSource = new BehaviorSubject({})
  getQuoteDetailsForMerge = this.mergeQuoteDetailsSource.asObservable()

  private readonly tileStatus = new Subject<any>()
  tileStatusEmitted$ = this.tileStatus.asObservable()

  private readonly rejectOnce = new Subject<any>()
  rejectOnceEmitted$ = this.rejectOnce.asObservable()

  private readonly enableMergeQuote = new Subject<any>()
  enableMergeQuote$ = this.enableMergeQuote.asObservable()

  constructor(
    private commonService: CommonService,
    private auth: AuthService,
    public activeCartService: ActiveCartFacade
  ) {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
      this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    })
    this.cartId$.subscribe((data) => {
      this.cartId = data
    })
  }

  getQuote(obj) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const urlParam = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'quoteListing',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, obj).pipe(share())
  }

  getQuoteDetail(id) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const obj = {
      quoteId: id,
    }
    const urlParam = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'quoteDetails',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, obj)
  }

  getQuoteDetailsFromList(id, fromDate, toDate) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const obj = {
      quoteId: id,
    }
    const urlParam = ['users', this.userType, 'rfqcart', this.rfqCartId]
    let lastPart = `quoteDetails?fields=DEFAULT`
    lastPart += `&fromDate=${fromDate}&toDate=${toDate}`
    urlParam.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, obj)
  }

  editQuote(quoteData) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const urlParams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'editquote',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, quoteData)
  }
  acceptQuote(quoteData) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const urlParams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'acceptquote',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, quoteData)
  }
  setQuotesForMerge(quotes) {
    this.mergeQuoteSource.next(quotes)
  }
  setQuoteDetailsForMerge(quotes) {
    this.mergeQuoteDetailsSource.next(quotes)
  }
  mergeQuote(quoteData) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const urlParams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'mergequote',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, quoteData)
  }
  rejectQuote(quoteData) {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    const urlParams = [
      'users',
      this.userType,
      'rfqcart',
      this.rfqCartId,
      'rejectQuote',
    ]
    const apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, quoteData)
  }

  reasonForReject() {
    const urlParam = ['users', this.userType, 'rfqcart', 'rejectReason']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }

  getRolesOfcust() {
    const urlParam = ['users', this.userType, 'isUserInViewRole']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }

  emitTileStatus(status) {
    this.tileStatus.next(status)
  }
  downloadDocument(docNumber) {
    const urlParam = ['users', 'current', 'rfqcart', 'downloadAttachment']
    const apiUrl = this.commonService.constructUrl(urlParam)
    let params = new HttpParams()
    params = params.append('docNumber', docNumber)
    return this.commonService.getData_PDF(apiUrl, params)
  }

  downloadQuoteDetailsExcel(obj) {
    const urlParam = [
      'users',
      this.userType,
      'rfqcart',
      'downloadQuoteDetailsExcel',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getQuoteData_Excel(apiUrl, obj)
  }

  downloadQuoteListing(obj) {
    const urlParam = ['users', 'current', 'quote', 'exportQuotes']
    const apiUrl = this.commonService.constructUrl(urlParam)
    let params = new HttpParams()
    //   params = params.append('createdDate', obj.createdDate);
    params = params.append('searchText', obj.searchText)
    //   params = params.append('quoteReference', obj.quoteReference);
    params = params.append('quoteStatusLabel', obj.quoteStatusLabel)
    //   params = params.append('quoteTotal', obj.quoteTotal);
    params = params.append('endDate', obj.endDate)
    params = params.append('startDate', obj.startDate)
    //   params = params.append('quoteRefreshFlag', obj.quoteRefreshFlag);
    params = params.append('', obj)
    return this.commonService.getData_Excel(apiUrl, params)
  }
  getInquiryType() {
    const urlParam = ['users', 'current', 'inquirydetails']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl, headerOptions)
  }

  getAllDocuments(orderNumber) {
    const urlParam = ['users', 'current', 'rfqcart', 'fetchAttachmentList']
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = {
      orderNo: orderNumber,
    }
    return this.commonService.getData(apiUrl, apiParams)
  }

  downloadAssociatedDocument(docNumber, docType, fileName, fileType) {
    const urlParam = ['users', 'current', 'rfqcart', 'downloadAttachment']
    const apiUrl = this.commonService.constructUrl(urlParam)
    let params = new HttpParams()
    params = params.append('docNumber', docNumber)
    params = params.append('docType', docType)
    params = params.append('fileName', fileName)
    params = params.append('fileType', fileType)
    if (fileType == 'pdf') {
      return this.commonService.getData_PDF(apiUrl, params)
    } else if (fileType == 'doc' || fileType == 'docx') {
      return this.commonService.getData_Doc(apiUrl, params)
    } else if (fileType == 'jpg' || fileType == 'JPG') {
      return this.commonService.getData_JPG(apiUrl, params)
    } else if (fileType == 'png' || fileType == 'PNG') {
      return this.commonService.getData_PNG(apiUrl, params)
    } else if (fileType == 'xls' || fileType == 'xlsx') {
      return this.commonService.getData_Excel(apiUrl, params)
    }
  }

  downloadQuoteDetails(obj) {
    const urlParam = ['users', 'current', 'rfqcart', 'downloadQuoteDetailsPDF']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData_PDF_Detail(apiUrl, obj)
  }

  emitRejectOnce(flag) {
    this.rejectOnce.next(flag)
  }

  emitMergeQuote(id) {
    this.enableMergeQuote.next(id)
  }

  submitInquiryToCSR(
    inquiryDropdownValue,
    description,
    quoteNumber,
    customerRefrence,
    Date
  ) {
    const urlParam = ['users', 'current', 'inquirydetails']
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = {
      inquiryCode: quoteNumber,
      inquiryDescription: description,
      inquiryTypeCode: inquiryDropdownValue,
      isRfqQuote: true,
      customerPO: customerRefrence,
      purchaseOrderDate: Date,
      orderId: quoteNumber,
    }
    return this.commonService.postData(apiUrl, apiParams, headerOptions)
  }
  getConfigMonth() {
    const urlParam = [
      'users',
      'current',
      'rfqcart',
      'quote-listing',
      'getConfigurableMonth',
    ]
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }
}
